import { USER_ROLE } from "./enums";

export const determineUserRole = (role) => {
	const userRoles = Array.isArray(role) ? role : [];
	return userRoles.includes(USER_ROLE.ADMIN)
		? USER_ROLE.ADMIN
		: userRoles.includes(USER_ROLE.INSTRUCTOR)
		? USER_ROLE.INSTRUCTOR
		: USER_ROLE.USER;
};